import { BASE_API_URL } from '../constants'
import Token from "./Token";

export const GpevAuthorizeApi = {
    authorize: (macAddress) => {
        return fetch(
            BASE_API_URL + '/api/gpev-authorize',
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken(),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ macAddress }),
            }
        ).then(r => {
            if (r.ok) return r.json()
            throw new Error(r.statusText)
        })
    }
}
